<template>
    <div class="main-content">
        <el-container style="height: 680px; border: 1px solid #eee">
            <el-aside width="250px" style="background-color: rgb(238, 241, 246)">
                <el-menu >
                    <el-menu-item :index="'1-'+i" v-for="(item,i) in courseList" :key="i" @click.native="getCourseVideo(item)">
                        <template slot="title">第{{item.sort}}节 ： {{item.title}}</template>
                    </el-menu-item>
                </el-menu>
            </el-aside>

            <el-container>
                <el-main>
                    <el-form class="detail-form-content"  :model="courseObj"  label-width="160px" >
                        <el-form-item label="操作介绍" class="input" prop="context">
                            <span>{{courseObj.context}}</span>
                        </el-form-item>
                        <el-form-item label="视频" class="input" prop="videoPath">
                            <video v-if="courseObj!=null" :src="url+'/upload/'+courseObj.videoPath" controls="controls" style="width:90%;height:auto"></video>
<!--                            <video src="http://localhost:8080/cocal_dec/upload/1723704002063.mp4" controls="controls" style="width:90%;height:auto"></video>-->
                        </el-form-item>
                    </el-form>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>
<script>
//    import base from '../../utils/base'
import base from "@/utils/base";
    export default {
        data() {
            return {
                courseList:[],
                courseObj:{},
                url:base.get().url,
            }
        },
        created(){
            this.initCourseList();
        },
        methods:{
            getCourseVideo(videoObj){
                this.courseObj = videoObj;
            },
            initCourseList(){
                let params = {type:'1'};
                this.$http({
                    url: "course/list",
                    method: "get",
                    params:params
                }).then(({data}) => {
                    if(data && data.code === 0){
                        this.courseList = data.data;
                        this.courseObj = this.courseList[0];
                    }
                });
            }
        }

    };
</script>
<style>
    .el-header {
        background-color: #B3C0D1;
        color: #333;
        line-height: 60px;
    }

    .el-aside {
        color: #333;
    }
</style>

<style scoped>
    .mainClass
    {
        width: 500px;
        height: 500px;
        background-color: #f0f0f0;
    }
    .el-menu-demo
    {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 100;
        width: 120px;
        /* background-color: rgb(167, 184, 184); */
    }
</style>